import { useCallback } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { useAppActions, useNav } from '../../AppContext'
import { ICON_SM } from '../../common/theme'
import iconBuilder from '../../img/blogger_950599.png'
import type { Question } from '../../types'

interface Props {
  question: Question
  testId?: string
}

// "Open in Builder" affordance — switches the active tab to the
// response builder and sets the focused question. Reused by
// BidQuestion's per-row toolbar so the icon + behaviour stay in one
// place.
export default function OpenInBuilderButton({ question, testId }: Props) {
  const { setCurrentQuestion } = useAppActions()
  const { setActiveTab } = useNav()
  const handleClick = useCallback(() => {
    setCurrentQuestion(question)
    setActiveTab('response')
  }, [question, setCurrentQuestion, setActiveTab])
  return (
    <Tooltip title="Open in Builder">
      <IconButton size="small" onClick={handleClick} sx={{ p: 0.375 }} data-testid={testId}>
        <img src={iconBuilder} alt="Builder" style={{ width: ICON_SM, height: ICON_SM }} />
      </IconButton>
    </Tooltip>
  )
}
